define('SageDotCom/DataLayer/Events/sectionVisibility',["jquery", "SageDotCom/DataLayer/Events/eventBase"], function ($, EventBase) {

    function SectionVisibilityEvent() {
        EventBase.call(this); // inherit eventBase
        this.name = "section_visibility"; // overwrite name
    }

    SectionVisibilityEvent.prototype = Object.create(EventBase.prototype);

    SectionVisibilityEvent.prototype.GenerateEventMetadata = function GenerateEventMetadata(sectionIndex, sectionHeading) {
        var eventData = {
            "event": this.getName(),
            "section_order": sectionIndex || 0,
            "section_heading": sectionHeading || ""
        };

        return eventData;
    }

    return new SectionVisibilityEvent();
});
